import * as wNumb from 'wnumb';

export const propertyTypeOptions = [
  { label: 'Property type', value: '' },
  { label: 'Terraced', value: 'terraced' },
  { label: 'Detached', value: 'detached' },
  { label: 'Semi-detached', value: 'semi_detached' },
  { label: 'Flat', value: 'flat' },
];

export const dependantOptions = [
  { label: 'Please select option', value: '' },
  { label: '0 dependants', value: 0 },
  { label: '1 dependant', value: 1 },
  { label: '2 dependants', value: 2 },
  { label: '3 dependants', value: 3 },
  { label: '4+ dependants', value: 4 },
];

export const discoverySourceOptions = [
  { label: 'How did you hear from us?', value: '' },
  { label: 'Social Media (Facebook, Instagram, YouTube)', value: 'Social media' },
  { label: 'Search Engine (Google, Bing, Yahoo)', value: 'Search engine' },
  { label: 'Property listing sites (Rightmove, Zoopla)', value: 'Listing site' },
  { label: 'Press article', value: 'Press' },
  { label: 'Tube platform advert (London Underground)', value: 'Tube ad' },
  { label: 'Friend or family recommendation', value: 'Friend or family' },
  { label: 'Other', value: 'Other' },
];

export const residencyOptions = [
  { label: 'Please select option', value: '' },
  { label: 'British passport', value: 'British passport' },
  { label: 'Indefinite leave to remain/ Settled Status', value: 'Indefinite leave to remain/ Settled Status' },
  { label: 'Lived in UK for more than 5 years', value: 'Lived in UK for more than 5 years' },
  { label: 'None of the above', value: 'None of the above' },
];

export const employmentOptions = [
  { label: 'Please select option', value: '' },
  { label: 'Employed', value: 'Employed' },
  { label: 'Self-employed', value: 'Self-employed' },
];

export const selfEmploymentOptions = [
  { label: 'Please select option', value: '' },
  { label: 'Sole trader', value: 'Sole trader' },
  { label: 'Company director (25%+ ownership)', value: 'Company director' },
];

/**
 * thousands of pounds lib-range (nouislider) tooltip format
 */
export const tooltipFormat = wNumb.default({
  mark: '.',
  thousand: ',',
  prefix: '£',
  suffix: 'K',
  decimals: 0,
  encoder: (value) => value * 0.001,
  decoder: (value) => value * 1000,
});

/**
 * display long number is short form i.e. 10K
 */
export function shortNumber(value: number): string {
  if (isNaN(value)) { return null; }// will only work value is a number
  if (value === null) { return null; }
  if (value === 0) { return null; }
  let abs = Math.abs(value);
  const rounder = 10 ** 1;
  const isNegative = value < 0; // will also work for negative numbers
  let key = '';
  const powers = [
    { key: 'Q', value: 10 ** 15 },
    { key: 'T', value: 10 ** 12 },
    { key: 'B', value: 10 ** 9 },
    { key: 'M', value: 10 ** 6 },
    { key: 'K', value: 1000 },
  ];
  // tslint:disable-next-line: prefer-for-of
  for (let i = 0; i < powers.length; i++) {
    let reduced = abs / powers[i].value;
    reduced = Math.round(reduced * rounder) / rounder;
    if (reduced >= 1) {
      abs = reduced;
      key = powers[i].key;
      break;
    }
  }
  return (isNegative ? '-' : '') + abs + key;
}

/**
   *
   */
export function calculateRange(
  budget: number,
): Partial<{
  start: number[],
  range: { min: number; max: number; },
  minLabel: string,
  maxLabel: string;
}> {
  const min = 100000;
  const minL = 400000; // min value to start range above 100K
  const max = 1200000;

  let from = budget
    ? Math.round(budget * 0.8)
    : min;

  if (from < min
    || from < minL) {
    from = min;
  }

  let to = budget
    ? Math.round(budget * 1.1)
    : max;

  if (to > max) {
    to = max;
  }

  const cap = budget || max;

  const start = sanitizeRange([from, cap]);

  const range = { min, max };

  return {
    start,
    range,
    minLabel: `${tooltipFormat.to(min)}`,
    maxLabel: `${tooltipFormat.to(max)}`,
  };
}

/**
 *
 */
export function sanitizeRange(values: Array<string | number>): number[] {
  const fallback = [100000, 1200000];

  try {
    const isArray: boolean = Array.isArray(values);

    if (!isArray) {
      return fallback;
    }

    const isValid = values
      .map((value) => !isNaN(+value))
      .reduce((accumulator, current) => accumulator && current, true);

    if (!isValid) {
      throw values;
    }

    return values.map((value) => +value);
  } catch (error) {
    console.log(error);

    return fallback;
  }
}

// eslint-disable-next-line max-len
export const ukPhoneRegex = /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/;